import Headroom from '../plugins/HeadroomPlugin.js';

export default function initHeadroom() {
	jQuery('#header').each(function(i, header) {
		const headroom = new Headroom(this, {
			offset: {
				up: 50,
				down: 120
			},
			onPin : function() {
				jQuery(header).trigger('pin');
				jQuery('body').addClass('header-pinned');
			},
			onUnpin : function() {
				jQuery(header).trigger('unpin');
				jQuery('body').removeClass('header-pinned');
			},
		});
		const resizeObserver = new ResizeObserver(resizeHandler);

		// initialise
		headroom.init();

		jQuery(header).data('headroom', headroom);

		document.documentElement.style.setProperty('--header-height', jQuery(header).outerHeight() + 'px');
		function resizeHandler() {
			document.documentElement.style.setProperty('--header-height', jQuery(header).outerHeight() + 'px');
		}

		resizeObserver.observe(document.body);
	});
}

export function initPinning(el) {
  $(function () {
    var $header = jQuery('#header');
    var $navigationWrapper = jQuery(el);
    $header.on('pin', function handlePin() {
      $navigationWrapper.removeClass('unpinned init-pinned');
    });
    $header.on('unpin', function handleUnpin() {
      $navigationWrapper.addClass('unpinned');
    });
  });
}
